import * as React from 'react';
import GroupFeedbackItem from './GroupFeedbackItem';
import { defineMessages } from 'react-intl';
import { intl } from 'i18n';

const messages = defineMessages({
    title: {
        id: 'GroupFeedback.title',
        defaultMessage: 'GROUP feedback'
    },
    description: {
        id: 'GroupFeedback.description',
        defaultMessage: 'Feedback will appear when a student submits a wrong answer.'
    },
    btn: {
        id: 'GroupFeedback.btn',
        defaultMessage: '+ Add group feedback'
    },
    note: {
        id: 'GroupFeedback.note',
        defaultMessage: 'Note: Group feedback overrides specific feedback.'
    },
})

export default class GroupFeedback extends React.Component<any, any> {

    render() {
        const { formatMessage } = intl;

        return (
            <div className='lxc-advanced-settings-block'>
                <div className='lxc-advanced-settings-block-title'>
                    {formatMessage(messages.title)}
                </div>
                <div className='lxc-advanced-settings-block-description'>
                    {formatMessage(messages.description)}
                </div>

                <div className='lxc-advanced-settings-form'>
                {
                    this.props.groupFeedbackList.map((groupFeedback: any, ind: number) => {
                        return (
                            <GroupFeedbackItem
                                key={ind}
                                id={Math.random()}
                                answersList={this.props.answersList}
                                groupFeedbackChange={this.props.groupFeedbackChange}
                                groupFeedbackRemove={this.props.groupFeedbackRemove}
                                {...groupFeedback}
                            />
                        )
                    })
                }
                    <button className='lxc-advanced-settings-another-field-btn' type='button' onClick={this.props.groupFeedbackAdd}>
                        {formatMessage(messages.btn)}
                    </button>
                    <div className='lxc-advanced-settings-note'>
                        {formatMessage(messages.note)}
                    </div>
                </div>

            </div>
        )
    }
};
